<template>
  <span class="ui-step-num">{{ formattedNum }}</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  num: {
    type: [String, Number],
    required: true,
  },
});

const formattedNum = computed(() => String(props.num).padStart(2, '0'));
</script>

<style scoped>
.ui-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--cyan-glow);
  border: 1px solid var(--cyan-glow);
  font-family: var(--font-brand);
  font-size: 11px;
  font-weight: 800;
  color: var(--cyan);
}
</style>
